export default {"src":"/_next/static/media/cart-dropdown-icon.22178ca7.svg","height":12,"width":16,"blurWidth":0,"blurHeight":0};